import FormHelper from "./../FormHelper.vue";
import "./SantanderFilter";
import sm_ from "./SantanderMixing";
import SantanderStepper from "./SantanderStepper";

export default {
    name: "SimulationSantander",
    props: {
        precoEUP: {
            type: Number,
            default: 0
        },
        prd_codigo: {
            type: Number,
            default: 0
        },
        origem: {
            type: String,
            default: null
        },
        isLogged: {
            type: Boolean,
            default: true
        },
    },
    components: {
        FormHelper,
        SantanderStepper
    },
    mixins: [sm_],
    data() {
        return {
            steps: [{
                    step: 1,
                    title: "Pre-Análise"
                },
                {
                    step: 2,
                    title: "Simulação"
                },
                {
                    step: 3,
                    title: "Resultado"
                }
            ],

            formPreAnalise: {
                tipoCliente: new this.$formInput(true, "cpf"),
                cliente: new this.$formInput(false),
                documentoCliente: new this.$formInput(true),
                dataNasc: new this.$formInput(true),
                telefone: new this.$formInput(true),
                valorSimular: new this.$formInput(true),
                attemptSubmit: false,
            },

            formContato: {
                nome: new this.$formInput(true),
                cep: new this.$formInput(true),
                uf: new this.$formInput(false),
                cidade: new this.$formInput(false),
                email: new this.$formInput(true),
                attemptSubmit: false,
            },

            valorEntradaPonte: 0,
            currentStep: 1,
            loader: false,
            loaderStep2: false,
            lastStep: 3,
            lastStepNoContact: 3,
            orcCetbtnEnabled: true,
        };
    },

    mounted() {
        $(this.$refs.simulationSantander).on("hidden.bs.modal", this.clearForm);
        this.step1();
        this.sm_origem = this.origem;
        this.sm_codigoProduto = this.prd_codigo;
    },

    methods: {
        step1: function() {
            this.getClientes();
            this.formPreAnalise.valorSimular.value = this.precoEUP;
        },

        step2: function() {
            this.formSimulacao.valorEntrada2Max =
                this.formPreAnalise.valorSimular &&
                this.formPreAnalise.valorSimular.value ?
                parseFloat(this.formPreAnalise.valorSimular.value) :
                0;
            this.formSimulacao.valorLiberado.value = 0;
            this.formSimulacao.valor.value = parseFloat(this.formPreAnalise.valorSimular.value);
            this.formSimulacao.valorEntrada2.value = 0;
            this.formSimulacao.valorEntrada.value = 0;
            this.formSimulacao.valorParcela.value = 0;
        },

        async proximo() {
            await this.getToken();
            let result;
            //Before
            switch (this.currentStep) {
                case 1:
                    this.step2();
                    result = await this.preAnalisar();
                    break;
                case 2:
                    result = await this.simular(false, true);
                    break;
                case 3:
                    result = true;
                    break;
            }
            if (!result) return;

            if (this.currentStep < this.lastStep) this.currentStep++;
            //After
            switch (this.currentStep) {
                case 1:
                    this.step1();
                    break;
                case 2:
                    this.recalcularValorParcela();
                    break;
                case 3:
                    break;
            }
        },

        anterior(step = null) {
            if (step != null) {
                this.currentStep = step;
                return;
            }
            if (this.currentStep > 1) this.currentStep--;
        },


        simularParcela: function() {
            this.formSimulacao.valorParcela.value = 0;
            this.recalcularValorParcela();
        },

        abrirCupom: function() {
            $("#cupomModal").modal("show");
        },

        removeCupom: function() {
            $("#cupomModal").modal("hide");
            this.formSimulacao.cupom.value = "";
            this.recalcularValorParcela();
        },

        closeCupom: function() {
            $("#cupomModal").modal("hide");
        },

        adicionaCupom: function() {
            $("#cupomModal").modal("hide");
            this.recalcularValorParcela();
        },


        clearForm() {
            this.formPreAnalise.tipoCliente = new this.$formInput(true, "cpf");
            this.formPreAnalise.cliente = new this.$formInput(false);
            this.formPreAnalise.documentoCliente = new this.$formInput(true);
            this.formPreAnalise.dataNasc = new this.$formInput(true);
            this.formPreAnalise.telefone = new this.$formInput(true);
            this.formPreAnalise.valorSimular = new this.$formInput(true);
            this.formPreAnalise.valorSimular.value = this.precoEUP;
            this.formPreAnalise.attemptSubmit = false;

            this.formSimulacao.valor = new this.$formInput(true);
            this.formSimulacao.parcela = new this.$formInput(true);
            this.formSimulacao.forma = new this.$formInput(true);
            this.formSimulacao.flex = new this.$formInput(false);

            this.formSimulacao.firstInstallmentMinimumDate = null;
            this.formSimulacao.firstInstallmentMaximumDate = null;
            this.formSimulacao.valorEntrada = new this.$formInput(false);
            this.formSimulacao.valorEntrada2 = new this.$formInput(false);
            this.formSimulacao.valorParcela = new this.$formInput(false);
            this.formSimulacao.valorEntrada2Step = 100;
            this.formSimulacao.valorEntrada2Max = 0;
            this.formSimulacao.valorLiberado = new this.$formInput(false);
            this.formSimulacao.firstInstallment = new this.$formInput(true);
            this.formSimulacao.attemptSubmit = false;

            this.formContato.nome.value = '';
            this.formContato.cep.value = '';
            this.formContato.uf.value = '';
            this.formContato.cidade.value = '';
            this.formContato.email.value = '';
            this.formContato.attemptSubmit = false;

            this.valorEntradaPonte = 0;
            this.currentStep = 1;

            this.loader = false;
            this.loaderStep2 = false;
            this.lastStep = 3;

            this.orcCetbtnEnabled = true;
            this.clearMixingData();
        },

        finalizar: function() {
            this.$emit('simulada', this.formSimulacao);
            if (this.formPreAnalise.tipoCliente.value != "revenda") {
                swal({
                    title: "Simulação de crédito pré-aprovada!",
                    icon: "success",
                    buttons: ["Fechar", "Cadastre a venda direta"],
                }).then((response) => {
                    if (response) {
                        let url = this.$SiteUrl + "/loja/minha-conta/cadastro-venda-direta";
                        var win = window.open(url, "_blank");
                        win.focus();
                        $("#close").trigger("click");
                        this.clearForm();
                    }
                });
            } else {
                swal({
                    title: "Simulação de crédito pré-aprovada!",
                    icon: "success",
                    buttons: ["Fechar", "Comprar"],
                }).then((response) => {
                    if (response) {
                        $("#close").trigger("click");
                        if (this.origem == "P") $("#buy-button").trigger("click");
                        this.clearForm();
                    }
                });
            }
        },

        finalizarSemCompra: function() {
            this.$emit('simulada', this.formSimulacao);
            if (this.isLogged) {
                swal({
                    title: "Parabéns seu crédito está pré-aprovado!",
                    icon: "success",
                    button: "Próximo passo - Ao encerrar a negociação com o seu cliente, vá até a Kombi para concluir e finalizar sua proposta.",
                }).then(() => {
                    $("#close").trigger("click");
                    this.clearForm();
                });
            } else {
                swal({
                    title: "Parabéns seu crédito está pré-aprovado!",
                    text: "Deseja uma visita técnica?",
                    icon: "success",
                    buttons: ["Não", "Sim"],
                }).then((response) => {
                    if (response) {
                        this.solicitarRevenda();
                    } else {
                        $("#close").trigger("click");
                        this.clearForm();
                    }
                });
            }
        },

        async solicitarContato() {
            this.formContato.attemptSubmit = true;
            if (this.formContatoErrors !== 0) return false;

            this.formPreAnalise.attemptSubmit = true;
            if (this.formPreAnaliseErrors !== 0) return false;

            let response = await this.postContato(this.formContato);
            if (response) {
                swal({
                    title: "Visita Técnica solicitada com sucesso!",
                    icon: "success",
                    button: "Logo mais você receberá contato de um parceiro Aldo Solar",
                }).then(() => {
                    $("#close").trigger("click");
                    this.clearForm();
                });
            }
        },

        solicitarRevenda: function() {
            if (this.steps.length == 3)
                this.steps.push({
                    step: 4,
                    title: "Visita Técnica"
                });
            this.currentStep = 4;
            this.lastStep = 4;
        },

        async verificarCep() {
            let valido = false;
            this.formContato.uf.value = '';
            this.formContato.cidade.value = '';
            let cep = this.formContato.cep.value.replace(/[-]+/g, "");
            if (cep.length == 8) {
                let cepResult = await this.getCepInfos(cep);
                if (cepResult != null) {
                    this.formContato.uf.value = cepResult.uf;
                    this.formContato.cidade.value = cepResult.localidade;
                    valido = true;
                }
            }
            if (!valido) {
                swal({
                    title: "Aviso",
                    text: "O CEP informado não é válido.",
                    icon: "warning",
                });
                this.formContato.cep.value = '';
            }
        }
    },

    computed: {
        clienteEscolhido: function() {
            if (this.currentStep > 1) {
                switch (this.formPreAnalise.tipoCliente.value) {
                    case "cpf":
                        return " - CPF: " + this.formPreAnalise.documentoCliente.value;
                    case "cnpj":
                        return " - CNPJ: " + this.formPreAnalise.documentoCliente.value;
                    case "revenda":
                        return " - Cliente: " + this.formPreAnalise.cliente.value.label;
                    default:
                        return '';
                }
            } else {
                return '';
            }
        },

        formContatoErrors: function() {
            const errors = Object.keys(this.formContato).filter(
                (key) =>
                this.formContato[key].validation &&
                !this.formContato[key].validation.status
            );
            return errors.length;
        },
    },

    watch: {

        "formPreAnalise.tipoCliente.value": function(val) {
            if (val !== "revenda") {
                this.formPreAnalise.cliente = new this.$formInput(false);
                this.formPreAnalise.documentoCliente = new this.$formInput(true);
            } else {
                this.formPreAnalise.cliente = new this.$formInput(true);
                this.formPreAnalise.documentoCliente = new this.$formInput(false);
            }
        },

        "formPreAnalise.cliente.value": function(val) {
            this.formPreAnalise.dataNasc.value = val.dateOfBirthFoundation;
            this.formPreAnalise.telefone.value = val.cellPhone;
            this.formPreAnalise.documentoCliente.value = val.document;
        },
    },
};